import React from 'react';
import RoleLayout from './RoleLayout';
import ComercialSidebar from '../pages/UsersArea/Comercial/Sidebar/ComercialSidebar';

const ComercialLayout = () => {
  return <RoleLayout sidebar={ComercialSidebar} />;
};

export default ComercialLayout;
